import { Resource } from "@/types"
import { createResource } from "frappe-ui"
import { computed, watch } from "vue"
import { useSelectedCustomer } from "./useCustomer"

const summary: Resource<{ contracts: boolean; subscriptions: boolean }> = createResource({
  url: "bookings.ui.api_handlers.subscription.get_commitments_summary",
});

watch(useSelectedCustomer(), () => summary.reload());

export function useCommitmentsSummary() {
  if (!summary.fetched && !summary.loading && !summary.error) {
    summary.reload();
  }
  return summary;
}

export function useCommitmentsLabel() {
  const res = useCommitmentsSummary();
  return computed(() => {
    const { contracts, subscriptions } = res.data || {};
    if (contracts && subscriptions) return __("Contracts and subscriptions");
    if (subscriptions) return __("Subscriptions");
    return __("Contracts");
  });
}
